import { CSSProperties } from "react";

export const XSolarisSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g filter="url(#filter0_d_218_403)">
        <circle cx="11" cy="11" r="10" fill="url(#paint0_linear_218_403)" />
        <circle cx="11" cy="11" r="9.5" stroke="black" strokeOpacity="0.15" />
      </g>
      <defs>
        <filter id="filter0_d_218_403" x="0" y="0" width="24" height="24">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.556863 0 0 0 0 0.556863 0 0 0 0 0.556863 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_218_403"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_218_403"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_218_403"
          x1="11"
          y1="1"
          x2="11"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BBBBBB" />
          <stop offset="1" stopColor="#9C9C9C" />
        </linearGradient>
      </defs>
    </svg>
  );
};
